import { TermBox } from "@/components/atoms/TermBox";
import { Option } from "@/generated/graphql_billing";
import { Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  contractedOptions: Option[];
};
export const TermBoxPlanCancelOptionTerms = ({ contractedOptions }: Props) => {
  return (
    <TermBox header="【オプション解約における注意事項】">
      {contractedOptions.map((opt) => (
        <div key={`opt-${opt.id}`}>
          <Font variant="mb">{opt.name}</Font>
          {opt.optionTerms.map((optTerm) => (
            <div key={`opt-term-${optTerm.id}`}>
              <Font variant="m">{optTerm.linkText}</Font>
            </div>
          ))}
        </div>
      ))}
    </TermBox>
  );
};
